import React from 'react';
import classNames from 'classnames';
import { ResultType } from 'twain-sport-fe-mono/enums';
import { IStandingsMatchParticipant, IStandingsParticipant } from 'twain-sport-fe-mono/interfaces';
import classes from './StandingsMatchParticipant.module.scss';

interface IProps {
    participantInfo: IStandingsParticipant;
    participant: IStandingsMatchParticipant;
}

export const StandingsMatchParticipant: React.FC<IProps> = (props) => (
    <div className={classes.container}>
        <span className={classes.nickname}>{props.participantInfo.nickname}</span>
        <span
            className={classNames(classes.point, {
                [classes.winner]: props.participant.result === ResultType.WON,
            })}
        >
            {props.participant.result ? props.participant.points : '-'}
        </span>
    </div>
);
